// El video de presentación de Tienda online, en el empty state (ADR-2026-10-30-la-lista-de-cambios-no-se-muestra).
// Vive aparte a propósito: la pantalla importa el chat, y `documentoGrafico.test.ts` no deja que un archivo
// que importa el chat monte un <iframe> (el html del modelo no sale del chat).
//
// Sin cookies de YouTube hasta que se aprieta play.
//
// Por ahora la sección es sólo para dev testers, en cualquier entorno
// (ADR-2026-10-31-video-de-tienda-online-solo-dev-testers).

import { useUserGroup } from "../../hooks/useUserGroup";

/** El id de YouTube del video de Tienda online. Mientras sea null, va el de muestra. */
const VIDEO_DE_TIENDA_ONLINE: string | null = null;
/** Uno de muestra: para ver cómo queda la sección hasta que esté el de verdad. */
const VIDEO_DE_MUESTRA = 'FUfGcZ092b0';

const VIDEO = VIDEO_DE_TIENDA_ONLINE ?? VIDEO_DE_MUESTRA;

/** ¿Se muestra la sección del video? Sólo a dev testers (mientras se sabe, no). */
export function useHayVideoDePresentacion(): boolean {
  const { isDevTester } = useUserGroup();
  return isDevTester === true;
}

export function VideoDePresentacion() {
  return (
    <div className="mt-5 aspect-video w-full overflow-hidden rounded-2xl bg-neutral-100 shadow-sm ring-1 ring-black/5">
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${VIDEO}?rel=0`}
        title="Qué podés hacer con Tienda online"
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className="h-full w-full"
      />
    </div>
  );
}
